export const ROUTES_WITH_RECAPTCHA_VALIDATION = [
  {
    route: '*payments/installments/webpay',
    method: 'POST',
    action: 'createWebpayPaymentRequest'
  },
  {
    route: '*payments/installments',
    method: 'GET',
    action: 'getClientInstallments'
  },
  {
    route: '*acquisitions/contacts',
    method: 'POST',
    action: 'createContactForm',
  },
  {
    route: '*payments/installments/vouchers/*',
    method: 'GET',
    action: 'getInstallmentVoucher'
  },
];
